import * as React from 'react';
import { Grid, Box } from '@moonpig/launchpad-components';
import { BlockItem } from '../BlockItem/BlockItem';
export var BlockLayoutB = function BlockLayoutB(_ref) {
  var items = _ref.items;
  return React.createElement(Grid, {
    gap: true
  }, React.createElement(Box, {
    width: {
      xs: 1,
      md: 1 / 2
    }
  }, React.createElement(BlockItem, items[0])), React.createElement(Box, {
    width: {
      xs: 1,
      md: 1 / 2
    }
  }, React.createElement(Grid, {
    gap: true
  }, React.createElement(Box, {
    width: 1
  }, React.createElement(BlockItem, items[1])), React.createElement(Box, {
    width: 1 / 2
  }, React.createElement(BlockItem, items[2])), React.createElement(Box, {
    width: 1 / 2
  }, React.createElement(BlockItem, items[3])))));
};